
import {
  defineComponent,
  onBeforeUnmount,
  onMounted,
  ref,
  watch,
  toRefs,
} from "vue";
// @ts-ignore - Linter hates this doesn't have a declaration file
import Chart from "chart.js/auto";
import ChartColors from "@/types/chartColors";
import ChartAreaBorderPlugin from "@/types/chartAreaBorderPlugin";
import chartAreaBorderPlugin_noBorder from "@/types/chartAreaBorderPlugin_noBorder";
import moment from "moment";

export default defineComponent({
  props: [
    "metricData",
    "dataLabels",
    "options",
    "dataProps",
    "dateLabel",
    "dualAxis",
    "isDashboardSubChart",
    "lineColorOverride",
  ],
  setup(props) {
    const chartRef: any = ref(null);
    let chart: any;
    const { metricData } = toRefs(props);
    let localData: any;

    const makeDataSets = (data: any) => {
      let datasets: any = [];

      props.dataProps.forEach((dataLabel: string, i: number) => {
        localData = data.map((row: any) => {
          const y = row[dataLabel].replace(",", ""); // In case older data has comma formating which messes up number calcs
          return {
            x: row[props.dateLabel],
            y: Number(y)
          }
        });
        const color = (props.lineColorOverride)? ChartColors[props.lineColorOverride] :  ChartColors[i];
        let dataset = {
          label: [props.dataLabels[i]],
          data: localData,
          fill: false,
          borderColor: color,
          backgroundColor: color,
          tension: 0.1,
          yAxisID: "yAxis",
        };

        if (props.dualAxis) {
          dataset.yAxisID = `y${i}`;
        }

        datasets.push(dataset);
      });

      return datasets;
    };

    const plugin = (props.isDashboardSubChart) ? chartAreaBorderPlugin_noBorder : ChartAreaBorderPlugin;

    const config: any = {
      type: "line",
      data: {
        datasets: makeDataSets(props.metricData),
      },
      options: props.options,
      plugins: [plugin],
    };

    config.options.scales.xAxis.ticks.callback = (
      tick: any,
      index: number,
      array: Array<any>
    ) => {
      const label = localData[index].x;

      if (array.length <= 13) {
        // OK only a few items so we'll show all labels
        return label;
      } else {
        if (index == 0 || index == array.length - 1) {
          return localData[index].x;
        } else {
          const itemsToShow = 11;
          let x = Math.ceil(array.length / itemsToShow);
          const monthRegex = new RegExp(/^[a-zA-Z]{3}-\d{2}$/i);
          const quarterRegex = new RegExp(/^[qQ][1-4]-\d{2}$/i);
          let shift = 0;

          // lets calculate a shift so that the second to last label selected is not right next to the actual last item in the array
          if (monthRegex.test(label)) {
            let _shift = Math.floor(array.length * 0.2);
            if (_shift > itemsToShow) {
              _shift = Math.floor(_shift / itemsToShow);
            }
            shift = _shift;
          } else if (quarterRegex.test(label)) {
            shift = 3;
          }

          return index % x != 0 || index + shift > array.length ? "" : label;
        }
      }
    };

    onMounted(() => {
      chart = new Chart(chartRef.value, config);
    });

    onBeforeUnmount(() => {
      chart.destroy();
    });

    watch(metricData, (newVal: any[]) => {
      config.data.labels = [];
      config.data.datasets = makeDataSets(newVal);
      chart.update();
    });

    return {
      chart,
      chartRef,
    };
  },
});
